import '../../App.css';

function ControlGastosPoliticasPage() {
  return (
    <div style={{
      padding: '20px',
    }}>
      <h1>Política de Privacidad</h1>
      <p>Última actualización: 27 de enero de 2025</p>
      <p>Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza el Servicio y le informa sobre sus derechos de privacidad y cómo la ley lo protege.</p>

      <h2>Definiciones</h2>
      <ul>
        <li><strong>Aplicación</strong>: Se refiere a Control de Gastos.</li>
        <li><strong>Datos Personales</strong>: Información que identifica a un individuo, como su dirección de correo electrónico utilizada para el inicio de sesión.</li>
        <li><strong>Datos de Uso</strong>: Datos recopilados automáticamente, como información técnica sobre su dispositivo al usar el Servicio.</li>
        <li><strong>Dispositivo</strong>: Cualquier dispositivo que pueda acceder al Servicio, como un ordenador o un teléfono móvil.</li>
        <li><strong>Servicio</strong>: Se refiere a la Aplicación y sus funcionalidades, incluyendo la gestión de gastos e ingresos.</li>
        <li><strong>Usted</strong>: El individuo que accede o utiliza el Servicio.</li>
      </ul>

      <h2>Recopilación y Uso de sus Datos Personales</h2>
      <p>No recopilamos datos personales de los usuarios. La aplicación está diseñada para funcionar sin necesidad de recopilar información personal.</p>

      <h2>Uso de sus Datos Personales</h2>
      <p>Dado que no recopilamos datos personales, no utilizamos dicha información para ningún propósito.</p>

      <h2>Enlaces a Otros Sitios Web</h2>
      <p>Nuestro Servicio puede contener enlaces a otros sitios web que no son operados por nosotros. No tenemos control sobre el contenido, las políticas de privacidad o las prácticas de sitios o servicios de terceros.</p>

      <h2>Cambios a esta Política de Privacidad</h2>
      <p>Podemos actualizar nuestra Política de Privacidad de vez en cuando. Le notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página. Le recomendamos revisar esta página periódicamente para estar al tanto de las actualizaciones.</p>

      <h2>Contáctenos</h2>
      <p>Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos por correo electrónico en <strong>soporte@controldegastos.com</strong>.</p>
    </div>
  );
}

export default ControlGastosPoliticasPage;